import React from 'react';
import { connect } from 'react-redux';

import SignIn from 'src/user-authentication';

const SignUp = ({ params, location }) => (
  <SignIn
    action="signup"
    key="signup"
    viewParams={{ ...params, query: location.query }}
  />
);

export default connect()(SignUp);
